<template>
  <div class="lcds-root-container">
    <!-- mini版分页器 -->
    <lc-rower v-if="isMini" class="lc-pagination__mini">
      <el-button
        type="text"
        :class="preDisabled ? 'button-disabled' : ''"
        :disabled="preDisabled"
        icon="el-icon-arrow-left"
        @click="handlePre"
      ></el-button>
      <el-input v-model="pageIndex" @change="handleCurrentPageChange"></el-input>
      <span>/</span>
      <span>{{ Math.ceil(pageOptions.total / pageOptions.pageSize) }}</span>
      <el-button
        :disabled="nextDisabled"
        :class="nextDisabled ? 'button-disabled' : ''"
        type="text"
        icon="el-icon-arrow-right"
        @click="handleNext"
      ></el-button>
    </lc-rower>
    <!-- 非mini -->
    <lc-rower v-else :class="background ? '' : 'lc-pagination__simple'">
      <el-pagination
        ref="pager"
        class="lc-pagination"
        :currentPage="pageOptions.pageIndex"
        :pageSize="pageOptions.pageSize"
        :total="pageOptions.total"
        :layout="pageOptions.layout"
        :pagerCount="pagerCount"
        :pageSizes="pageSizes"
        @current-change="handleCurrentPageChange"
        @size-change="handlePageSizeChange"
      >
        <div class="lc-pagination-sizer" v-if="pageOptions.layout.indexOf('sizes') > -1 && pageStyle !== 'small'">
          每页
          <el-select v-model="pageOptions.pageSize" size="small" @change="handlePageSizeChange">
            <el-option
              v-for="(size, index) in pageSizes"
              :key="'size_' + index"
              :label="size"
              :value="size"
            ></el-option> </el-select
          >条
        </div>
        <slot />
      </el-pagination>
      <div class="lc-pagination-sizer" v-if="pageOptions.layout.indexOf('sizes') > -1 && pageStyle == 'small'">
        每页
        <el-select v-model="pageOptions.pageSize" size="small" @change="handlePageSizeChange">
          <el-option
            v-for="(size, index) in pageSizes"
            :key="'size_' + index"
            :label="size"
            :value="size"
          ></el-option> </el-select
        >条
      </div>
      <div class="lc-pagination__jump" v-if="pageOptions.layout.indexOf('jumper') > -1">
        <div>跳至</div>
        <el-input @change="handleCurrentPageChange" v-model="jumpToPageIndex"> </el-input><span>页</span>
      </div>
    </lc-rower>
  </div>
</template>

<script>
export default {
  name: 'LcPagination',
  props: {
    // 配置选项
    paginationOptions: {
      type: Object,
      default: () => {}
    },
    // pageSizes
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50]
    },
    pageStyle: {
      type: String,
      default: 'default'
    },
    background: {
      type: Boolean,
      default: false
    },
    pagerCount: {
      type: Number,
      default: 5
    },
    isCurrentPageTotal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMini() {
      return this.pageStyle === 'mini';
    }
  },
  watch: {
    paginationOptions: {
      handler(val) {
        this.pageOptions = Object.assign({}, this.pageOptions, this.paginationOptions);
      },
      immediate: true,
      deep: true
    },
    jumpToPageIndex(val,oldVal) {
      if(Number.isNaN(Number(val))) {
        this.jumpToPageIndex = oldVal;
      }
    }
  },
  data() {
    return {
      pageIndex: 1,
      jumpToPageIndex: 1,
      pageOptions: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        layout: 'total, slot, prev, pager, next'
      },
      nextDisabled: false,
      preDisabled: false
    };
  },
  mounted() {
    this.initBtnStatus();
  },
  methods: {
    initBtnStatus() {
      this.preDisabled = false;
      this.nextDisabled = false;
      if (this.pageOptions.pageIndex < 1 || this.pageOptions.pageIndex == 1) {
        if (this.isMini) {
          this.pageIndex = 1;
        } else {
          this.pageOptions.pageIndex = 1;
          this.jumpToPageIndex = 1;
        }
        this.preDisabled = true;
      }
      let maxPage = Math.ceil(this.pageOptions.total / this.pageOptions.pageSize);
      if (this.pageOptions.pageIndex > maxPage || this.pageOptions.pageIndex == maxPage) {
        if (this.isMini) {
          this.pageIndex = maxPage;
        } else {
          this.pageOptions.pageIndex = maxPage;
          this.jumpToPageIndex = maxPage;
        }
        this.nextDisabled = true;
      }
    },
    handleCurrentPageChange(pageIndex) {
      this.pageOptions.pageIndex = pageIndex;
      this.initBtnStatus();
      this.$emit('current-change', Number(this.pageOptions.pageIndex));
    },
    handlePageSizeChange(pageSize) {
      this.pageOptions.pageSize = pageSize;
      this.pageOptions.pageIndex = 1;
      this.$emit('size-change', Number(this.pageOptions.pageSize));
    },
    handlePre() {
      this.pageIndex--;
      this.handleCurrentPageChange(this.pageIndex);
    },
    handleNext() {
      this.pageIndex++;
      this.handleCurrentPageChange(this.pageIndex);
    }
  }
};
</script>
